<i18n>
{
  "fr": {
      "typeContact": "Type : ",
      "title":"Civilité : ",
      "other": "Autre : ",
      "lastName" : "Nom : ",
      "firstName": "Prénom : ",
      "fixedLinePhone" : "Tél(fixe) : ",
      "mobilePhone": "Tél(portable) :",
      "town": "Commune :",
      "zipCode": "Code postal :",
      "street": "Rue : ",
      "numberStreet": "N° Police : ",
      "email": "E-mail : ",
      "siret": "Siret : ",
      "businessName": "Raison sociale : ",
      "updatedAt":"Date de mise à jour du contact : "
    }
}
</i18n>

<template>
  <div id="admin-data" class="block">
    <b-list-group flush v-for="contact in property.contacts" :key="contact.id">
      <b-list-group-item>
        <b-link v-b-toggle="'collpase' + contact.id">
          {{ getFullName(contact) }}
          <b-badge variant="primary" class="pull-right">
            <v-icon name="info" />
          </b-badge>
        </b-link>
        <b-collapse :id="'collpase' + contact.id">
          <b-card>
            <b-row>
              <b-col md="6">
                <p class="text">
                  {{ $t('typeContact') }}
                  <span>{{ getTypeContact(contact.typeContact, contact.otherTypeContact) }}</span>
                </p>
                <p class="text">
                  {{ $t('other') }}
                  <span>{{ getTitleContact(contact.otherTypeContact) }}</span>
                </p>
                <p class="text">
                  {{ $t('title') }}
                  <span>{{ getTitleContact(contact.title) }}</span>
                </p>
                <p class="text">
                  {{ $t('lastName') }}
                  <span>{{ contact.name }}</span>
                </p>

                <p class="text">
                  {{ $t('firstName') }}
                  <span>{{ contact.firstName }}</span>
                </p>

                <p class="text">
                  {{ $t('fixedLinePhone') }}
                  <span>{{ contact.fixedLinePhone }}</span>
                </p>
                <p class="text">
                  {{ $t('mobilePhone') }}
                  <span>{{ contact.mobilePhone }}</span>
                </p>
                <p class="text">
                  {{ $t('updatedAt') }}
                  <span>{{ formatDate(contact.updatedAt) }}</span>
                </p>
              </b-col>
              <b-col md="6">
                <p class="text">
                  {{ $t('town') }}
                  <span>{{ contact.town }}</span>
                </p>
                <p class="text">
                  {{ $t('zipCode') }}
                  <span>{{ contact.zipCode }}</span>
                </p>
                <p class="text">
                  {{ $t('street') }}
                  <span>{{ contact.street }}</span>
                </p>
                <p class="text">
                  {{ $t('numberStreet') }}
                  <span>{{ contact.numberStreet }}</span>
                </p>
                <p class="text">
                  {{ $t('email') }}
                  <span>{{ contact.email }}</span>
                </p>
                <p class="text">
                  {{ $t('siret') }}
                  <span>{{ contact.siret }}</span>
                </p>
                <p class="text">
                  {{ $t('businessName') }}
                  <span>{{ contact.businessName }}</span>
                </p>
              </b-col>
            </b-row>
          </b-card>
        </b-collapse>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { VALUE_OTHER } from '../../constants/params';
import { formatDate } from '../../utils/formatDate';
export default {
  name: 'ContactData',
  computed: {
    ...mapState({ property: (state) => state.refProperties.property }),
  },
  methods: {
    getFullName(contact) {
      const title = contact.title == VALUE_OTHER ? '' : this.getTitleContact(contact.title);

      return `${title} ${contact.name}  ${contact.firstName ? contact.firstName : ''}`;
    },
    getTitleContact(title) {
      return title ? `${title.charAt(0).toUpperCase()}${title.slice(1)}` : '';
    },
    getTypeContact(types, otherTypeContact) {
      let text = '';
      const options = {
        'maitre-ouvrage': "Maître d'ouvrage",
        'maitre-oeuvre': "Maître d'œuvre",
        'bureau-etudes': "Bureau d'étude",
        particulier: 'Particulier',
        promoteur: 'Promoteur',
        payeur: 'Payeur',
        gardien: 'Gardien',
        gestionnaire: 'Gestionnaire',
        proprietaire: 'Propriétaire',
        locataire: 'Locataire',
        autre: 'Autre',
      };

      Object.entries(types).map((type) => {
        let typeContact = type[1];
        type != 'autre'
          ? (text += `${options[typeContact]}, `)
          : otherTypeContact
          ? (text += `Autre: ${otherTypeContact}, `)
          : text;
      });
      return text;
    },
    formatDate(value) {
      return formatDate(value);
    },
  },
};
</script>
